const routes = {
	login: '/login',
	logout: '/logout',
	bots: '/bots',
	clients: '/accounts',
	users: '/users',
	tasks: '/tasks',
	sales: '/sales',
	inbox: '/inbox',
	resetPassword: '/reset_password',
	forgotPassword: '/forgot_password',
	dummy: '/dummy',
	templates: '/templates',
	requests: '/requests',
	accounts: '/account-settings',
	reports: '/reports',
	notification: '/notifications',
	preview: '/preview',
	privacy: '/privacy-policy',
	payments: '/payments',
	salesPublic: '/sales_public',
	inboxPublic: '/inbox_public',
	reportPublic: '/reports_public',
	rawData: '/raw_data',
	email: '/email',
	creditCard: '/credit_card',
	publicClient: '/public_client',
	onboard: '/get-started',
	settings: '/settings',
	landingPage: '/landing-page',
	dashboard: '/home',
	partner: '/partner',
	marketingResources: '/resources',
	client: '/client',
	addPipeline: '/sales/add-pipeline',
	customField: '/custom-field',
	subscription: '/subscriptions',
	pipeline: '/pipeline',
	linkSent: '/link_sent'
};

export default routes;
